export const PaperAirplaneIcon = () => (
  <svg
    fill="none"
    height="45"
    viewBox="0 0 44 45"
    width="44"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1975 28.0741L37.5939 6.47876L20.8822 29.1538L18.9325 38.3318L14.1975 28.0741Z"
      fill="#E67F5A"
    />
    <path
      d="M27.5669 21.5953L41.7718 3.50928L38.151 35.3623L21.4393 29.1537L27.5669 21.5953Z"
      fill="#EC9F83"
    />
    <path
      d="M23.9384 33.7336L20.0466 38.3318L21.0386 30.2336L25.6172 31.812L23.9384 33.7336Z"
      fill="#E05F31"
    />
    <path
      d="M11.6907 17.2764L37.5939 4.58911L13.6404 26.9942L3.3349 22.4052L11.6907 17.2764Z"
      fill="#EC9F83"
    />
    <path
      d="M31.6834 5.80322C25.525 9.00298 16.1336 13.8441 10.8135 16.5962C5.49339 19.3317 1.0115 21.686 0.857538 21.8352C0.686473 21.9678 0.549622 22.2497 0.549622 22.4486C0.549622 22.6476 0.686473 22.9294 0.857538 23.062C1.0115 23.2112 3.81695 24.3884 7.06718 25.6815L12.986 28.0358L13.5847 29.4781C13.9098 30.2573 15.1414 33.1753 16.2876 35.9605C17.4508 38.7458 18.4772 41.1166 18.5627 41.2161C18.6482 41.3322 18.9391 41.4316 19.2128 41.4316C19.6404 41.4316 20.1023 40.9343 23.2499 37.1377L26.808 32.8603L28.9463 33.5897C37.5338 36.574 37.8588 36.6734 38.2865 36.4911C38.7825 36.259 38.7141 36.5574 39.5523 30.9868C40.5787 24.1065 42.7341 9.84851 43.4013 5.45506C43.7263 3.31636 44 1.32687 44 1.02845C44 0.448181 43.6237 -0.016037 43.1789 0.000541687C43.0249 0.000541687 37.8417 2.62003 31.6834 5.80322ZM41.1775 7.72639C38.6115 24.8028 37.1574 34.369 37.089 34.4187C37.0719 34.4519 35.156 33.7887 32.8637 32.9763C30.5714 32.1474 27.2357 30.9371 25.4395 30.3071C23.6604 29.6605 22.1551 29.1134 22.1209 29.0802C22.1038 29.0471 25.7474 24.3718 30.2464 18.6852C41.4512 4.52663 41.5196 4.44374 41.5709 4.62611C41.6051 4.709 41.434 6.10164 41.1775 7.72639ZM36.3876 5.77006C35.7889 6.31717 20.4786 20.0778 15.2783 24.7199C14.2861 25.5986 13.4308 26.2949 13.3795 26.2618C13.3281 26.2286 11.224 25.3831 8.67519 24.3718C6.14343 23.3439 4.00513 22.4652 3.91959 22.3823C3.85117 22.316 7.3922 20.3928 11.7886 18.1215C16.1849 15.8501 23.6433 12.0038 28.3476 9.56667C33.0519 7.12955 36.935 5.14006 36.9864 5.12348C37.0377 5.12348 36.764 5.40532 36.3876 5.77006ZM35.327 9.3014C35.2244 9.41746 32.111 13.3633 28.3818 18.0717C24.6697 22.7802 21.1971 27.1736 20.6668 27.8368C20.1365 28.5 19.6746 29.1963 19.6404 29.3952C19.5036 30.0418 18.8535 35.8777 18.8535 36.3584C18.8535 36.6734 18.7851 36.7895 18.6996 36.69C18.443 36.4413 14.9019 27.8202 14.9533 27.6047C14.9875 27.5052 15.6204 26.8586 16.3731 26.1789C22.0524 21.0891 31.4439 12.6504 33.2229 11.0588C35.2586 9.21851 35.7034 8.83719 35.327 9.3014ZM23.0617 31.4179C23.8999 31.7495 24.6526 32.081 24.7381 32.1474C24.8237 32.2303 23.9684 33.4074 22.7709 34.8663C21.6077 36.2755 20.6326 37.4195 20.6155 37.3863C20.5129 37.3035 21.3169 30.821 21.4195 30.821C21.4708 30.821 22.2064 31.0863 23.0617 31.4179Z"
      fill="#6F3365"
    />
    <path
      d="M14.7705 37.7923L11.6911 42.9206"
      stroke="#6F3365"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M12.3715 31.3133L9.29205 36.4416"
      stroke="#6F3365"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M26.6268 38.8716L23.5474 44"
      stroke="#6F3365"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
)

export default PaperAirplaneIcon
